<template>
  <div class="daifuDetails-top1">
    <div class="daifuDetails-header_money">
      <div class="touxiang">
        <img :src="info.headimgurl" />
        <div class="t-info">您的好友：{{ info.nickName }}</div>
        <div class="t-t">来晚啦，对方已删除订单～</div>
      </div>
      <div class="line">
        <img src="https://img.yzcdn.cn/upload_files/2020/10/15/FmtU16DyT-4vtC7NrM_HKYzzL19X.png" />
      </div>
      <div class="main">
        <div class="m-t">
          <img
            src="https://img.yzcdn.cn/upload_files/2020/10/13/Fos1uRx_-n1_s_B7xlDst3p79Le7.png"
          />
          <div class="suc">订单已删除</div>
        </div>
        <div class="m-b">好友已经删除订单啦，下次再帮TA付款吧～</div>
      </div>
    </div>
  </div>
</template>

<script>
import { CountDown } from 'vant'
export default {
  name: '',
  components: {
    [CountDown.name]: CountDown
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  mounted() {

  },
  methods: {}
}
</script>

<style lang="scss" scope="">
.daifuDetails-top1 {
  padding: 12px 15px;
  box-sizing: border-box;
  .daifuDetails-header_money {
    width: 343px;
    box-sizing: border-box;
    border-radius: 4px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    .touxiang {
      width: 100%;
      background-image: url('https://img.yzcdn.cn/upload_files/2020/10/14/FkKkXfhN75JGqzUI6N94XCmqOddP.png');
      background-size: 100% 100%;
      padding-top: 10px;
      padding-bottom: 9px;
      img {
        width: 54px;
        margin: 0 auto;
        height: 54px;
        border: 2px solid #ffffff;
        box-sizing: border-box;
        filter: drop-shadow(0px 4px 5px rgba(255, 38, 56, 0.05));
        border-radius: 50%;
      }
      .t-info {
        font-weight: 500;
        font-size: 16px;
        margin-top: 10px;
        margin-bottom: 5px;

        color: #333333;
      }
      .t-t {
        font-size: 14px;
        color: #999999;
      }
    }
    .line {
      width: 100%;
      height: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .main {
      width: 100%;
      background: #fff;
      border-radius: 4px;
      padding-top: 12px;
      padding-bottom: 33px;
      position: relative;
      .m-t {
        font-size: 20px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        font-weight: 500;

        img {
          width: 20px;
          height: 20px;
          margin-right: 6px;
          position: absolute;
          left: 95px;
        }
      }
      .m-b {
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>
